var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 14 14"}},[_c('rect',{attrs:{"width":"13","height":"13","x":".5","y":".5","fill":_vm.color,"stroke":_vm.color,"rx":"2.5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }